import commonSlice from '@/state/common.slice';
import store from '@/state/store';

export default (i: number) => {
  store.dispatch(commonSlice.actions.hideMessage(i));
};
